import { Routes } from '@front-app/constants/routes';
import { Route } from 'vue-router';
import { PhoenixRouteConfig } from '../Model';

export const communityRoutes: PhoenixRouteConfig[] = [
	{
		meta: {
			title(): string { return 'Manage Community' as string; },
		},
		path: 'csr/community/:communityId',
		name: Routes.MANAGE_COMMUNITY,
		redirect: { name: Routes.MANAGE_COMMUNITY_EDIT_COMMUNITY },
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				communityId: route.params.communityId,
			};
		},
		component: () => import(/* webpackChunkName: "manage-community" */ '@front-app/views/csr/community/ManageCommunity.vue'),
		children: [
			{
				meta: {
					title(): string { return 'Manage Community' as string; },
				},
				path: 'edit-community',
				name: Routes.MANAGE_COMMUNITY_EDIT_COMMUNITY,
				component: () => import(/* webpackChunkName: "manage-community" */ '@front-app/views/csr/community/EditCommunity.vue'),
			},
			{
				meta: {
					title(): string { return 'Contents' as string; },
				},
				path: 'contents',
				name: Routes.MANAGE_COMMUNITY_CONTENTS,
				component: () => import(/* webpackChunkName: "manage-community" */ '@front-app/views/csr/community/CommunityContents.vue'),
			},
			{
				meta: {
					title(): string { return 'Branding' as string; },
				},
				path: 'settings',
				name: Routes.MANAGE_COMMUNITY_SETTINGS,
				component: () => import(/* webpackChunkName: "manage-community" */ '@front-app/views/csr/community/CommunitySettings.vue'),
			},
		],
	},
];
